import React from 'react';
import { usePwaInstall } from '../hooks/usePwaInstall';
import './InstallAppPrompt.css';

const InstallAppPrompt: React.FC = () => {
  const { visible, mode, installing, dismiss, install } = usePwaInstall();

  if (!visible || !mode) return null;

  return (
    <div className="pwa-install-backdrop" role="presentation" onClick={dismiss}>
      <div
        className="pwa-install-card"
        role="dialog"
        aria-labelledby="pwa-install-title"
        aria-describedby="pwa-install-desc"
        onClick={(e) => e.stopPropagation()}
      >
        <button type="button" className="pwa-install-close" onClick={dismiss} aria-label="Close">
          ×
        </button>

        <div className="pwa-install-icon-wrap" aria-hidden>
          <img src="/icons/icon.svg" alt="" className="pwa-install-icon" width={72} height={72} />
        </div>

        <h2 id="pwa-install-title" className="pwa-install-title">
          Install App
        </h2>
        <p id="pwa-install-desc" className="pwa-install-desc">
          Add this app to your home screen for quick access — works like a native app on your phone.
        </p>

        {mode === 'native' ? (
          <div className="pwa-install-actions">
            <button
              type="button"
              className="pwa-install-btn pwa-install-btn--primary"
              onClick={() => void install()}
              disabled={installing}
            >
              {installing ? 'Installing…' : 'Install app'}
            </button>
            <button type="button" className="pwa-install-btn pwa-install-btn--ghost" onClick={dismiss}>
              Not now
            </button>
          </div>
        ) : (
          <div className="pwa-install-ios">
            <ol className="pwa-install-ios-steps">
              <li>
                Tap <strong>Share</strong>{' '}
                <span className="pwa-install-ios-icon" aria-hidden>
                  ⎋
                </span>{' '}
                in Safari
              </li>
              <li>
                Scroll and tap <strong>Add to Home Screen</strong>{' '}
                <span className="pwa-install-ios-icon" aria-hidden>
                  ＋
                </span>
              </li>
              <li>
                Tap <strong>Add</strong> in the top right
              </li>
            </ol>
            <button
              type="button"
              className="pwa-install-btn pwa-install-btn--primary pwa-install-btn--full"
              onClick={dismiss}
            >
              Got it
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default InstallAppPrompt;
